import { render, staticRenderFns } from "./DemocraticAutonomy2.vue?vue&type=template&id=2d68ff98&scoped=true&"
import script from "./DemocraticAutonomy2.vue?vue&type=script&lang=js&"
export * from "./DemocraticAutonomy2.vue?vue&type=script&lang=js&"
import style0 from "./DemocraticAutonomy2.vue?vue&type=style&index=0&id=2d68ff98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68ff98",
  null
  
)

export default component.exports